import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_EXPORT_PRICE_DETAIL:
      return { ...action.value };
    default:
      return state;
  }
};
